export enum TicketActionSuccessEvent {
  AddSuccess = '7T:Tickets.AddSuccess',
  PayoutSuccess = '7T:Tickets.PayoutSuccess',
  CancelSuccess = '7T:Tickets.CancelSuccess',
}
